import { Fragment } from 'react'
import Link from 'next/link'

import logger from '../../../lib/logger'
import { Dialog, Disclosure, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon, MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/20/solid'

import { classNames } from '../../../lib/helpers'


export default function CategoryFilters({ categories=[], category={}, mobileFiltersOpen=false, setMobileFiltersOpen }) {
  logger.info("Component.CategoryFilters rendering.");

  // Use different Tags depending if it's a category page or Apps directory 
  const ParentCatTag = category?.id ? `p` : `h2`  // If it's a category page then use just p for filters pCat
  const CatTag = category?.id ? `p` : `h3`  // If it's a category page then use just p for filters cat

  const sortFunc = (nameA, nameB) => {
    if(nameA < nameB) { return -1; }
    if(nameA > nameB) { return 1; }      
  }

  const parentCategories = categories?.filter(cat => !cat?.parent_id)?.sort((a, b) => sortFunc(a.name, b.name)) 

  const childCategories = (parentCategory) => {
    try {
      return categories?.filter(cat => cat?.parent_id === parentCategory?.id)?.sort((a, b) => sortFunc(a.name, b.name))
    } catch {};
    return []
  }

   
  return <>

    <div className="mb-6">

      <form className="hidden lg:block">
        
        

        {parentCategories?.map((parentCategory) => (
          <Disclosure defaultOpen={category?.parent_id === parentCategory?.id} as="div" key={parentCategory?.id} className=" border-gray-200">
            {({ open }) => (
              <>
                <ParentCatTag className="flow-root">
                  <Disclosure.Button 
                    title={parentCategory?.name}
                    className={classNames(open || ((parseInt(category?.parent_id) === parseInt(parentCategory?.id))) ? 
                      "bg-crisp-600 text-white" : 
                      "text-gray-400 hover:text-gray-500 bg-white ", 
                      "py-3 px-3 w-full flex items-center justify-between text-sm")}
                  >
                    {/* bg-gray-100 text-gray-900 group rounded-md py-2 px-2 flex items-center text-sm font-medium */}
                    {/* bg-crisp-800 text-white */}
                    {/*                         "text-crisp-400 hover:text-crisp-500" : 
                      "text-gray-400 hover:text-gray-500",  */}

                    <span className={classNames(open || (parseInt(category?.parent_id) === parseInt(parentCategory?.id)) ? 
                          "text-white" : "text-gray-900", "font-semibold truncate")}
                    >
                      {parentCategory?.name}
                    </span>
                    <span className="ml-6 flex items-center">
                      {open ? (
                        <MinusSmallIcon className="h-5 w-5" aria-hidden="true" />
                      ) : (
                        <PlusSmallIcon className="h-5 w-5" aria-hidden="true" />
                      )}
                    </span>
                  </Disclosure.Button>
                </ParentCatTag>
                
                <Disclosure.Panel  className=" pb-3">
                  <div className="space-y-4 bg-gray-100">                      
                    <ul role="list" className=" text-sm font-normal text-gray-900 space-y-0  ">
                      {childCategories(parentCategory)?.map((cat) => (
                        <li key={cat.id} >
                          <a
                            href={`/apps/categories/${cat.slug}`}
                            className={classNames(cat?.id === category?.id ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'block py-3 px-5')}>

                            <CatTag className='truncate'>
                              {cat.name}
                            </CatTag>

                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Disclosure.Panel>

              </>
            )}
          </Disclosure>
        ))}
      </form>
    </div>
  
  

    {/* Mobile filter dialog */}
    <Transition.Root show={mobileFiltersOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 flex z-40 sm:hidden" onClose={setMobileFiltersOpen}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <Transition.Child
          as={Fragment}
          enter="transition ease-in-out duration-300 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
        >
          <div className="ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto">
            <div className="px-4 flex items-center justify-between">
              <h2 className="text-lg font-medium text-gray-900">
                App Categories
              </h2>
              <button
                type="button"
                className="-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400 focus:outline-none"
                onClick={() => setMobileFiltersOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            {/* Filters */}
            <form className="mt-4">
              {parentCategories?.map((parentCategory) => (
                <Disclosure as="div" key={parentCategory?.id} className="border-t border-gray-200 px-4 py-6">
                  {({ open }) => (
                    <>
                      <h3 className="-mx-2 -my-3 flow-root">
                        <Disclosure.Button className="px-2 py-3 bg-white w-full flex items-center justify-between text-sm text-gray-400">
                          <span className="font-medium text-gray-900">
                            {parentCategory.name}
                          </span>
                          <span className="ml-6 flex items-center">
                            <ChevronDownIcon
                              className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-5 w-5 transform')}
                              aria-hidden="true"
                            />
                          </span>
                        </Disclosure.Button>
                      </h3>
                      <Disclosure.Panel className="pt-6">
                        <div className="space-y-6">
                          
                          <ul role="list" className="text-sm font-medium text-gray-900 space-y-0 pb-6 border-b border-gray-200">
                            {childCategories(parentCategory)?.map((cat) => (
                              <li key={cat.id} >
                                <Link
                                  href={`/apps/categories/${cat.slug}`}
                                  className={classNames(cat?.id === category?.id ? 'bg-crisp-50' : '', 'block hover:bg-gray-100 py-3 px-2')}>

                                  {cat.name}

                                </Link>
                              </li>
                            ))}
                          </ul>

                        </div>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </form>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition.Root>
  
  
  </>;
}
